import { render } from "./multipay.vue?vue&type=template&id=dbb62184"
import script from "./multipay.vue?vue&type=script&lang=js"
export * from "./multipay.vue?vue&type=script&lang=js"

import "./multipay.vue?vue&type=style&index=0&id=dbb62184&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__